import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    IconButton,
    Box
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';

interface ConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    moduleOwner: string;
    statusdata: boolean;
    setstatusdata: React.Dispatch<React.SetStateAction<boolean>>;
    handleYes: () => void;
    chekmodulw: number;
    editteammemver:number
}

const ConfirmPopup: React.FC<ConfirmDialogProps> = ({ open, onClose, onConfirm, moduleOwner, statusdata, setstatusdata, handleYes ,chekmodulw,editteammemver}) => {
    //     const handleYes = () => {
    //   // Handle the "Yes" logic here
    //   console.log("User clicked Yes");
    // //   onConfirm(); // or add logic directly here
    //   setstatusdata(true)
    // };
  const { copyid } = useParams();
    const handleNo = () => {
        // Handle the "No" logic here
        console.log("User clicked No");
        //   onClose(); // or add logic directly here
        setstatusdata(false)

    };

    const handleYesClick = () => {
        handleYes();
        setstatusdata(true);
        onClose();
    };

    const handleNoClick = () => {
        setstatusdata(false);
        onClose();
    };
    console.log(statusdata, "statusdata8889999999999999")
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ marginTop: "10px" }}>
                <Box sx={{ display: "flex" }}>
                    <CheckCircleIcon color="success" sx={{ verticalAlign: 'middle', mr: 1, width: "22px", height: "22px", color: "#3BA755" }} />
                    <Typography sx={{ fontSize: "16px", fontWeight: "600", }}> Confirm Submission</Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 9, top: 20, width: "10px", height: "10px", border: "1px solid #000" }}
                >
                    <CloseIcon sx={{ width: "15px", height: "15px" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
          <Typography>
  {copyid?.startsWith("id:")
    ? "Are you sure you want to approve the member"
    : chekmodulw ? (
        <>
          Are you sure you want to submit? This will trigger an email to the module owner <strong>{moduleOwner}</strong>
        </>
      ) : editteammemver === 3 ? (
        <>
          Are you sure you want to submit? This will trigger an email to the Team member <strong>{moduleOwner}</strong>
        </>
      ) : editteammemver === 2 ? (
        <>
          Are you sure you want to submit? This will trigger an email to the Module owner <strong>{moduleOwner}</strong>
        </>
      ) : (
        <>
          Are you sure you want to submit? This will trigger an email to the module owner <strong>{moduleOwner}</strong> for approval.
        </>
      )
  }
</Typography>





            </DialogContent>
            <DialogActions sx={{ justifyContent: 'end', pb: 2 }}>
                {/* <Button variant="outlined" sx={{ width: "112px" }} color="error" onClick={handleYes}>
                    Yes
                </Button>
                <Button variant="outlined" sx={{ width: "112px", border: "1px solid #E7E8E9", color: "#000" }} onClick={handleNo}>
                    No
                </Button> */}
                <Button variant="outlined" sx={{ width: "112px" }} color="error" onClick={handleYesClick}>
                    Yes
                </Button>
                <Button variant="outlined" sx={{ width: "112px", border: "1px solid #E7E8E9", color: "#000" }} onClick={handleNoClick}>
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmPopup;